import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
    block: {
        marginBottom: theme.spacing(2)
    },
    divider: {
        marginBottom: theme.spacing(1)
    },
    header: {
        marginBottom: theme.spacing(1)
    }
});


interface LoadingProps {
    isLoading?: boolean;
}

interface DetailsBlockProps {
    title: string;
    itemsRightOfTitle?: JSX.Element[] | JSX.Element;
    rightItems?: JSX.Element[] | JSX.Element;
}

type BlockProps = WithStyles<"block" | "divider" | "header"> & DetailsBlockProps & LoadingProps;

const DetailsBlock: React.SFC<BlockProps> = (props) => {
    const { classes, isLoading } = props;

    return <Grid item xs={12} className={classes.block}>
        <Grid className={classes.header} container direction="row" justify="space-between" alignItems="center">
            <Grid item><Typography variant="h6">{props.title}</Typography></Grid>
            <Grid item>{props.itemsRightOfTitle}</Grid>
            <Grid item>{props.rightItems}</Grid>
        </Grid>
        <Divider className={classes.divider} />
        {isLoading ?
            <Grid container justify="center" alignItems="center"><CircularProgress /></Grid> :
            <Grid alignItems="flex-start" container spacing={4}>
                {React.Children.map(props.children, item => item)}
            </Grid>
        }
    </Grid>
}

export default withStyles(styles)(DetailsBlock);


// WEBPACK FOOTER //
// ./src/components/tables/DetailsBlock.tsx